export default "__VITE_ASSET__wrPzIwgn__"